export const ROUTES = {
	VALIDATE_CODE: '',
	BIOMETRY: 'biometria',
	VIEW_CODE: 'finalizar',
	BLOCK_PROCESS: 'bloqueo'
};
